import { CargoTemperatureInputFieldBM } from '../../types/BusinessModel/CargoTempLog/CargoTemperatureInputFieldBM';
import { CargoTemperatureInputField } from '../../types/ViewModel/CargoTempLog/CargoTemperatureInputField';

export const mapCargoTemperatureInputField = (bm: CargoTemperatureInputFieldBM): CargoTemperatureInputField => {
    return {
        cargoTemperatureInputFieldId: bm.cargoTemperatureInputFieldId,
        fieldName: bm.fieldName,
        isManditory: bm.isManditory,
        isSelected: bm.cargoTemperatureInputFieldId === 1,
    };
};

export const mapCargoTemperatureInputFields = (bms: CargoTemperatureInputFieldBM[]): CargoTemperatureInputField[] =>
    bms ? bms.map(mapCargoTemperatureInputField) : [];

export const mapCargoTemperatureInputFieldBM = (vm: CargoTemperatureInputField): CargoTemperatureInputFieldBM => {
    return {
        cargoTemperatureInputFieldId: vm.cargoTemperatureInputFieldId,
        fieldName: vm.fieldName,
        isManditory: vm.isManditory,
    };
};

export const mapCargoTemperatureInputFieldBMs = (vms: CargoTemperatureInputField[]): CargoTemperatureInputFieldBM[] =>
    vms ? vms.map(mapCargoTemperatureInputField) : [];
